import { useEffect, useState } from "react";
import { hospedesService } from "../services/hospedesService";
import { Hospedes } from "../interfaces/Hospedes";

export const useHospedes = (reservaId: number | null, fetch: boolean) => {
  const [hospedes, setHospedes] = useState<Hospedes[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchHospedes = async () => {
      if (reservaId && fetch) {
        // Verifica se reservaId não é null e se fetch é verdadeiro
        setLoading(true); // Inicia o carregamento
        try {
          const data = await hospedesService(reservaId);
          if (data.length > 0) {
            setHospedes(data);
          } else {
            setError("Nenhum hóspede encontrado");
          }
        } catch (err) {
          setError("Erro ao buscar hóspedes");
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false); // Termina o carregamento se reservaId for null ou fetch for falso
      }
    };

    fetchHospedes();
  }, [reservaId, fetch]);

  return { hospedes, loading, error };
};
